var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.851,
    height: 16.166,
    viewBox: "0 0 18.851 16.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a8a8a8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.851 16.166) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.718,6.76a1.347,1.347,0,0,0-.233-.017H4.186l.29-.135a2.7,2.7,0,0,0,.762-.54L8.967,2.339a1.4,1.4,0,0,0,.2-1.787A1.349,1.349,0,0,0,7.139.377L.4,7.12a1.349,1.349,0,0,0,0,1.907h0l6.744,6.744a1.349,1.349,0,0,0,2.023-.135,1.4,1.4,0,0,0-.2-1.787L5.244,10.115a2.7,2.7,0,0,0-.674-.492l-.4-.182H17.41a1.4,1.4,0,0,0,1.423-1.133A1.349,1.349,0,0,0,17.718,6.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPass);
export default __webpack_public_path__ + "static/media/arrow_pass.1f70ab41512942dd4672e49f252b9278.svg";
export { ForwardRef as ReactComponent };